<template>
    <select class="form-control font-weight-bold"  id="selecTipoVendedor" v-model="valor"  @change="$emit('evento', valor)">
        <option value="">Seleccione tipo de vendedor...</option>
        <option v-for="d in $store.state.dataTipoVendedor" :key="d.Id" :value="d.Id"  >{{d.tipo}}</option>
    </select>
</template>

<script>
export default {
    name:"SelectTipoVendedor",
    props:['valor_entrada'],
     data(){
        return{
            valor:'',
            data:[]
            }
        },
        beforeMount() {
           setTimeout(() => {

                this.valor = this.valor_entrada;
            }, 100);
        },
         watch: {
            valor_entrada(newQuestion, oldQuestion) {
                this.valor=newQuestion;
            }
        }
    

}
</script>

